// 保留 Ctrl/Cmd 点击的浏览器原生行为，避开组件库链接处理中的 preventDefault。
export default function preserveModifiedLinkNavigation(event) {
  if (event.button !== 0 || (!event.ctrlKey && !event.metaKey) || event.defaultPrevented) return
  const link = event.target.closest('a[href]')
  if (link && !link.hasAttribute('disabled') && link.getAttribute('aria-disabled') !== 'true') {
    event.stopImmediatePropagation()
  }
}
